'use strict';/* global define */define('modules/modals/services/modals/modals/reload/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "$window"];
function controller($scope,$window){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.reload=reload;ctrl.close=$scope.close;// ---
/**
     * Reload after an error
     *
     * @tested
     */function reload(){$window.location.reload();}}module.exports=controller;});
